import React from 'react';
import PropTypes from 'prop-types';
import Config from '../../config';

// Utils
import getWindow from 'Utils/get-window';
import ObjectUtil from 'Utils/object-util';

// Components
import WebLink from './web-link';
import withT from 'ComponentLibrary/hocs/withT';

import connector from 'Utils/connector';
import connectFeatureFlags from 'Webapp/shared/app/connectors/connectFeatureFlags';

const DNS_LINK_INCLUDE_PROPS = ['href', 'name', 'className', 'onClick'];

function DataProtectionLink(props) {
  const { auto, label, onClick, t, featureFlags } = props;

  const showPrivacyManager = (e) => {
    if (e) {
      e.preventDefault();
    }

    const window = getWindow();
    if (featureFlags.GOOGLE_CMP) {
      // The queue is normally installed by the googlefc bootstrap partial;
      // recreating it here covers pages rendered without JS externals.
      window.googlefc = window.googlefc || {};
      window.googlefc.callbackQueue = window.googlefc.callbackQueue || [];
      window.googlefc.callbackQueue.push(() =>
        window.googlefc.showRevocationMessage(),
      );
      return;
    }

    window._sp_?.gdpr?.loadPrivacyManagerModal?.(
      Config.SOURCEPOINT_GDPR_PRIVACY_MANAGER_ID,
    );
  };
  const handleClick = onClick
    ? (e) => {
        showPrivacyManager(e);
        onClick(e);
      }
    : showPrivacyManager;

  const linkProps = ObjectUtil.pick(
    Object.assign({}, props, { onClick: handleClick }),
    DNS_LINK_INCLUDE_PROPS,
  );

  if (auto) {
    showPrivacyManager();
  }
  // Google requires the EEA/UK re-open link be labeled "Privacy and cookie
  // settings"; non-compliance can get the consent message disabled (G5).
  const defaultLabel = featureFlags.GOOGLE_CMP
    ? t('privacy_and_cookie_settings')
    : t('data_protection');
  return <WebLink {...linkProps}>{label || defaultLabel}</WebLink>;
}

DataProtectionLink.propTypes = {
  auto: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
  t: PropTypes.func.isRequired,
  featureFlags: PropTypes.shape({
    GOOGLE_CMP: PropTypes.bool,
  }).isRequired,
};

DataProtectionLink.defaultProps = {
  auto: false,
  onClick: null,
};

export default connector(connectFeatureFlags)(withT(DataProtectionLink));
